import React, { lazy, Suspense } from "react";
import Loader from "../components/shared/Loader/Loader";

const Blog = lazyWithProps(() => import("../pages/Blog/Blog"));
const IntroducingArticle = lazyWithProps(
  () => import("../pages/Blog/BlogArticle/IntroducingClubpassGreeceGymsSalons")
);
const GymDayPass = lazyWithProps(
  () => import("../pages/Blog/BlogArticle/GymDayPassVsMembershipBenefits")
);
const FreeClients = lazyWithProps(
  () => import("../pages/Blog/BlogArticle/HowGymsAndSalonsInGreeceCanGetFreeClients")
);
const ReasonsToJoin = lazyWithProps(
  () => import("../pages/Blog/BlogArticle/ReasonsToJoinClubpassGreece")
);
const DayPassRise = lazyWithProps(() => import("../pages/Blog/BlogArticle/DayPassGymsRiseGreece"));
const AirbnbModel = lazyWithProps(
  () => import("../pages/Blog/BlogArticle/WhatGymsSalonsGreeceCanLearnFromAirbnbModel")
);
const BuildBrand = lazyWithProps(
  () => import("../pages/Blog/BlogArticle/BuildingStrongGymBrandStrategiesForLocal")
);
const FillEmptySlots = lazyWithProps(
  () => import("../pages/Blog/BlogArticle/HowToFillEmptyTimeSlotsWithoutSpendingOnAds")
);
const GymGoers = lazyWithProps(
  () => import("../pages/Blog/BlogArticle/WhatGymGoersLookForInSalonOrSpaGreece")
);
const InvisibleBusiness = lazyWithProps(
  () => import("../pages/Blog/BlogArticle/BusinessInvisibleToLocalsClubpassSolution")
);
const Top10Wellness = lazyWithProps(
  () => import("../pages/Blog/BlogArticle/Top10WellnessExperiencesThessaloniki")
);
const HowWellnessBusinesses = lazyWithProps(
  () => import("../pages/Blog/BlogArticle/HowWellnessBusinessesInAthensAreFilling")
);
const CrossPromotionAthensBeautyWellness = lazyWithProps(
  () => import("../pages/Blog/BlogArticle/CrossPromotionAthensBeautyWellness")
);
const SmallGymsAthensVsChains = lazyWithProps(
  () => import("../pages/Blog/BlogArticle/SmallGymsAthensVsChains")
);
const SmartWaysYogaStudiosInAthens = lazyWithProps(
  () => import("../pages/Blog/BlogArticle/SmartWaysYogaStudiosInAthens")
);
const HowToMakeTheMostOfDayPassInPatras = lazyWithProps(
  () => import("../pages/Blog/BlogArticle/HowToMakeTheMostOfDayPassInPatras")
);
const AthensWellnessBusinessOffPeakGrowth = lazyWithProps(
  () => import("../pages/Blog/BlogArticle/AthensWellnessBusinessOffPeakGrowth")
);

function lazyWithProps<T extends object>(
  importFunc: () => Promise<{ default: React.ComponentType<T> }>
) {
  const LazyComponent = lazy(importFunc);
  return (props: any) => (
    <Suspense fallback={<Loader />}>
      <LazyComponent {...props} />
    </Suspense>
  );
}

export const blogRoutes = [
  { path: "blog", element: <Blog /> },

  {
    path: "blog/introducing-clubpass-greece-gyms-salons",
    element: <IntroducingArticle language="en" />,
  },
  {
    path: "blog/sas-parousiazoume-to-clubpass-gymnastiria-salonia-ellada",
    element: <IntroducingArticle language="gr" />,
  },

  { path: "blog/gym-day-pass-vs-membership-benefits", element: <GymDayPass language="en" /> },
  { path: "blog/gymnastirio-day-pass-vs-syndromi-ofeli", element: <GymDayPass language="gr" /> },

  {
    path: "blog/how-gyms-and-salons-in-greece-can-get-free-clients",
    element: <FreeClients language="en" />,
  },
  {
    path: "blog/pos-na-vreis-neous-pelates-dorean-gymnastirio-salon-ellada",
    element: <FreeClients language="gr" />,
  },

  { path: "blog/5-reasons-to-join-clubpass-greece", element: <ReasonsToJoin language="en" /> },
  { path: "blog/5-logoi-gia-na-eggrapsete-sto-clubpass", element: <ReasonsToJoin language="gr" /> },

  { path: "blog/day-pass-gyms-rise-greece", element: <DayPassRise language="en" /> },
  { path: "blog/gymnastiria-me-imimerisia-pasa-anodos", element: <DayPassRise language="gr" /> },

  {
    path: "blog/what-gyms-salons-greece-can-learn-from-airbnb-model",
    element: <AirbnbModel language="en" />,
  },
  {
    path: "blog/ti-mporoun-na-mathoun-gymnastiria-salon-airbnb-montelo",
    element: <AirbnbModel language="gr" />,
  },

  {
    path: "blog/building-strong-gym-brand-local-market-dominance",
    element: <BuildBrand language="en" />,
  },
  {
    path: "blog/khtizontas-ena-isxuro-gymnastiriako-brand-topiki-kiriarxia",
    element: <BuildBrand language="gr" />,
  },

  {
    path: "blog/how-to-fill-empty-time-slots-without-spending-on-ads",
    element: <FillEmptySlots language="en" />,
  },
  {
    path: "blog/pos-na-gemisteis-kenes-ores-xoris-diafimisi",
    element: <FillEmptySlots language="gr" />,
  },

  {
    path: "blog/what-gym-goers-look-for-in-salon-or-spa-greece",
    element: <GymGoers language="en" />,
  },
  {
    path: "blog/ti-psachnoun-oi-pelates-gymnastiriou-se-salon-i-spa-ellada",
    element: <GymGoers language="gr" />,
  },

  {
    path: "blog/business-invisible-to-locals-clubpass-solution",
    element: <InvisibleBusiness language="en" />,
  },
  {
    path: "blog/epicheirisi-aorati-topikoi-clubpass-lisi",
    element: <InvisibleBusiness language="gr" />,
  },

  {
    path: "blog/top-10-wellness-experiences-thessaloniki",
    element: <Top10Wellness language="en" />,
  },
  {
    path: "blog/10-empeiries-eyexias-thessaloniki",
    element: <Top10Wellness language="gr" />,
  },

  {
    path: "blog/wellness-businesses-athens-off-peak-bookings",
    element: <HowWellnessBusinesses language="en" />,
  },
  {
    path: "blog/epixeiriseis-eyexias-athina-kenes-ores",
    element: <HowWellnessBusinesses language="gr" />,
  },

  {
    path: "blog/10-cross-promotion-athens-beauty-wellness",
    element: <CrossPromotionAthensBeautyWellness language="en" />,
  },
  {
    path: "blog/10-synergasia-athina-omorfia-eyexia",
    element: <CrossPromotionAthensBeautyWellness language="gr" />,
  },

  {
    path: "blog/small-gyms-athens-vs-chains",
    element: <SmallGymsAthensVsChains language="en" />,
  },
  {
    path: "blog/mikra-gymnastiria-athina-vs-alysides",
    element: <SmallGymsAthensVsChains language="gr" />,
  },

  {
    path: "blog/yoga-studios-athens-no-subscription",
    element: <SmartWaysYogaStudiosInAthens language="en" />,
  },
  {
    path: "blog/yoga-studios-athina-xoris-syndromes",
    element: <SmartWaysYogaStudiosInAthens language="gr" />,
  },

  {
    path: "blog/how-to-use-day-pass-patras-guide",
    element: <HowToMakeTheMostOfDayPassInPatras language="en" />,
  },
  {
    path: "blog/pos-na-xrisimopoiiseis-imerisio-passo-patras",
    element: <HowToMakeTheMostOfDayPassInPatras language="gr" />,
  },

  {
    path: "blog/athens-wellness-business-off-peak-growth",
    element: <AthensWellnessBusinessOffPeakGrowth language="en" />,
  },
  {
    path: "blog/epicheiriseis-wellness-athina-off-peak-anaptiksi",
    element: <AthensWellnessBusinessOffPeakGrowth language="gr" />,
  },
];
